import { ApprovalStatus } from 'enums';
import { messages } from 'i18n';

const { approvalStatusLabels } = messages.submissionQueuePage;

const approvalStatusConfig: Record<ApprovalStatus, string> = {
  [ApprovalStatus.Approved]: approvalStatusLabels.approved,
  [ApprovalStatus.Flagged]: approvalStatusLabels.flagged,
  [ApprovalStatus.Rejected]: approvalStatusLabels.rejected,
};

export const getApprovalStatusLabel = (value: ApprovalStatus) => approvalStatusConfig[value];
